module.exports = __webpack_public_path__ + "img/main-md.7660af9.webp";